import type { SimpleChoice } from '@/features/ChoicesLists/Simple/types';
import type { HttpClientResponse } from '@/services/api/HttpClient';
import { HttpService } from '@/services/api/HttpService';

export class ChoicesSimpleHttpService extends HttpService {
  loadChoices(
    choices: string[],
  ): HttpClientResponse<{ choices: SimpleChoice[] }> {
    return this.httpClient.get('choices', {
      params: {
        name: choices,
      },
    });
  }
}
